import type { EditSchemaDefinition } from "@/shared/components/CRUD/types";
import { CRUD } from "@/shared/components";
import {
  MigrationsListQuery,
  MigrationShowQuery,
} from "@/admin/entities/migrations";
import { MigrationDetails } from "../";
import {
  useMigrationsManagement,
  type MigrationRow,
  MigrationsSchemas,
} from "../model";

const getMigrationTitle = () => "Миграция";

const editSchema: EditSchemaDefinition = {
  details: {
    label: "Детали миграции",
    type: "show" as const,
    getTitle: getMigrationTitle,
    showComponent: MigrationDetails,
    showQuery: MigrationShowQuery,
  },
};

/**
 * UI компонент для управления миграциями
 */
export function Migrations() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useMigrationsManagement();

  return (
    <CRUD<MigrationRow>
      listQuery={MigrationsListQuery}
      listPollInterval={5000}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={MigrationsSchemas.filterSchema}
      editSchema={editSchema}
      editQuery={MigrationShowQuery}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
